'use client'

import CloseButton from '@component/closeButton'
import MaskLoading from '@component/loading/mask'
import Menu from '@component/menu'
import { useMenuContext } from '@component/menu/context'
import { houseList } from '@router'
import { stopPropagation } from '@utils'
import classNames from 'classnames'
import { get, isFunction } from 'lodash-es'
import { useCallback } from 'react'
import { getSlugData } from '../../../utils'
import useHouseSearchContext from '../../context'

export default function FilterItemBase({
  children,
  text,
  className,
  popupTitle = text,
  popupWidth = 375,
  active = false,
  onClear,
  onClose,
  onConfirm,
  totals,
  isLoading = false,
  right = false,
  showButton = true
}) {

  const { toggleFilterOpen } = useHouseSearchContext()
  const openHandle = useCallback(() => toggleFilterOpen(true), [toggleFilterOpen])
  const closeHandle = useCallback(() => {
    toggleFilterOpen(false)
    onClose && onClose()
  }, [toggleFilterOpen, onClose])
  return (
    <div className={classNames(
      'inline-block flex-1 text-center relative xs-s:min-w-0',
      // 'before:w-2 before:h-16 before:bg-neutral before:absolute before:left-0 before:top-1/2 before:-translate-y-1/2',
      'after:w-2 after:h-16 after:bg-neutral after:absolute after:right-0 after:top-1/2 after:-translate-y-1/2',
      className
    )}>
      <Menu
        left={!right}
        right={right}
        hover={false}
        onClose={closeHandle}
        onOpen={openHandle}
        popup={<Popup title={popupTitle} onClear={onClear} onConfirm={onConfirm} totals={totals} isLoading={isLoading} showButton={showButton}>{children}</Popup>}
        width={popupWidth}
        contentClassName='rounded-md'
        fixedBg
      >
        <Span active={active}>{text}</Span>
      </Menu>
    </div>
  )
}

export function getFilterRouter(state) {
  const { slug, type, searchParams } = state
  const houseRoute = getSlugData(slug)
  return handle => {
    isFunction(handle) && handle(houseRoute)
    const slug = houseRoute.toSlug()
    return [
      houseList(type, slug, searchParams),
      slug
    ]
  }
}

export function getFilterTotals(data, useTotalCount = true) {
  const selected = get(data, 'headers.x-selected-count')
  const total = get(data, 'headers.x-total-count')
  if (!selected && useTotalCount) {
    return total
  } else {
    return selected || total
  }
  // return selected || total
  // let res = get(data, 'headers.x-selected-count')
  // if (!res && useTotalCount) {
  //   res = get(data, 'headers.x-total-count')
  // }
  // return res
}

export function FilterItemSpan({
  className,
  children,
  active = false,
  open = false,
  onClick,
  id,
  showArrow = true
}) {

  return (
    <button
      type='button'
      id={id}
      className={classNames(
        'h-38 text-sm text-font lg:text-base sm:font-light inline-flex px-6 items-center justify-center cursor-pointer whitespace-nowrap lg:h-54 lg:px-10 2xl:px-16 w-full',
        'hover:bg-[#E2E3E6] xs-s:overflow-hidden',
        { '!bg-white shadow-menu !text-primary xs-s:relative xs-s:z-10 xs-s:rounded-sm': open },
        // { 'text-primary': active },
        // { '!bg-neutral': active && !open },
        // active ? 'text-primary' : 'text-black',
        className
      )}
      onClick={onClick}
    >
      <span className='whitespace-nowrap overflow-hidden text-ellipsis'>{children}</span>
      {
        showArrow && (
          <i className={classNames('icon ml-4 md:ml-6 !text-sm md:font-bold', open ? 'icon-arrow-up' : 'icon-arrow-down', { 'text-primary': active })}></i>
        )
      }
    </button>
  )
}

function Span({
  active,
  children
}) {

  const { visible } = useMenuContext()
  return (
    <FilterItemSpan active={active} open={visible}>{children}</FilterItemSpan>
  )
}

function Popup({
  title,
  totals,
  children,
  onClear,
  onConfirm,
  isLoading,
  showButton
}) {

  const { toggleVisible } = useMenuContext()
  const confirmHandle = useCallback(() => {
    toggleVisible(false)
    isFunction(onConfirm) && onConfirm()
  }, [toggleVisible, onConfirm])
  return (
    <PopupContent title={title} totals={totals} isLoading={isLoading} showButton={showButton} onClear={onClear} onConfirm={confirmHandle}>
      {children}
    </PopupContent>
  )
}

export function PopupContent({
  title,
  children,
  showButton = true,
  onClear,
  onConfirm,
  onClose,
  totals,
  isLoading,
  closeable = false,
  className,
  contentClassName
}) {

  return (
    <div className={classNames('px-16 py-24 relative', className)} onClick={stopPropagation}>
      {title && <div className='text-font text-lg font-medium text-left'>{title}</div>}
      {closeable && <CloseButton className='absolute right-10 top-10' onClick={onClose}></CloseButton>}
      <div className={classNames('mt-16', contentClassName)}>{children}</div>
      {
        showButton && (
          <div className='flex gap-x-8 mt-16'>
            <button type='button' className='button-primary-out flex-1' onClick={onClear}>Clear</button>
            <button type='button' className='button-orange flex-[2]' onClick={onConfirm}>Show {totals} properties</button>
          </div>
        )
      }
      <MaskLoading transparent loading={isLoading}></MaskLoading>
    </div>
  )
}